//
// PromptElement.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "./VisualElement";
import "../promptDefinitions/PromptDefinition";
import "./prompt/PromptSpecialization";
import "../common/values/DefaultValue";
import "@sas-dvr/ltjs-commons/models/prompt/MissingValueCheckboxLocationType";

var PromptElement = createModule("BIRD::PromptElement", ["commons::PropertyOwner","commons::BaseModel","BIRD::BIRDModel","BIRD::VisualElement"], EventDispatcher, [
    ,
    {
        interactOnAggregateData: 2,
        defaultValue: 1,
        promptDefinition: 1,
        specialization: 1,
        missingValueCheckboxLocation: 4,
        required: 2,
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default PromptElement;
